export default __webpack_public_path__ + "static/media/custom-logo.beab3aee.svg";